import { encodeUrlValue } from 'src/adapters/urlEncoding';
import { TAXONOMY_MULTISELECT_DELIMITER } from '../../urlDelimiters';

const encodeSegment = (segment: string): string =>
  segment
    .split(TAXONOMY_MULTISELECT_DELIMITER)
    .map(encodeUrlValue)
    .join(TAXONOMY_MULTISELECT_DELIMITER);

export const buildListingsBasePath = (
  leadingSegments: readonly string[],
  levels: string[],
): string => `/${[...leadingSegments, ...levels].map(encodeSegment).join('/')}`;
